import React, { useCallback } from 'react';
import { useTranslations } from '@storebrand-digital/fms-translations-react';
import ArrowUp from './ArrowUp';
import { TopBase, Container } from './styled';
function Top() {
    var getText = useTranslations().getText;
    var scrollToTop = useCallback(function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);
    return (React.createElement(TopBase, { onClick: scrollToTop },
        React.createElement(Container, null,
            React.createElement("span", null, getText('footer.top')),
            React.createElement(ArrowUp, null))));
}
export default Top;
